var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735899949345,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5155,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 112m57.9 0l312.2 0q57.9 0 57.9 57.9l0 684.2q0 57.9-57.9 57.9l-312.2 0q-57.9 0-57.9-57.9l0-684.2q0-57.9 57.9-57.9Z",
    fill: "#495057",
    "p-id": 5156
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.14 193.16m8 0l365.72 0q8 0 8 8l0 592.7q0 8-8 8l-365.72 0q-8 0-8-8l0-592.7q0-8 8-8Z",
    fill: "#FFFFFF",
    "p-id": 5157
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.72 139.7m11.6 0l81.14 0q11.6 0 11.6 11.6l0-0.02q0 11.6-11.6 11.6l-81.14 0q-11.6 0-11.6-11.6l0 0.02q0-11.6 11.6-11.6Z",
    fill: "#868E96",
    "p-id": 5158
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M334.92 828.1m28.98 0l0.02 0q28.98 0 28.98 28.98l0 0.02q0 28.98-28.98 28.98l-0.02 0q-28.98 0-28.98-28.98l0-0.02q0-28.98 28.98-28.98Z",
    fill: "#868E96",
    "p-id": 5159
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M414.74 425.32a16.22 16.22 0 0 1-20.74-3.6 29.3 29.3 0 0 0-7.34-6.58 35.06 35.06 0 0 0-19.2-4.78 35.42 35.42 0 0 0-24 8.2 25.44 25.44 0 0 0-9.46 20.3q0 16.86 25 27.14l23 9.4q28 11.34 40.92 27.66t12.94 40q0 31.78-21.12 52.5t-52.82 20.88q-30 0-49.4-17.74a73.02 73.02 0 0 1-19.3-30.44 17.84 17.84 0 0 1 12.8-23.38 17.82 17.82 0 0 1 20.82 12.86 34.34 34.34 0 0 0 5.18 11.28q10.72 14.92 31.26 14.92a36.22 36.22 0 0 0 26.94-10.88 37.72 37.72 0 0 0 10.72-27.6 38.86 38.86 0 0 0-1.86-12.3 31.28 31.28 0 0 0-5.8-10.28 46.5 46.5 0 0 0-10.2-8.8 98.14 98.14 0 0 0-14.88-7.82l-22.2-9.24q-47.16-20-47.18-58.48a55.52 55.52 0 0 1 19.8-43.4q19.78-17.6 49.24-17.6a64.92 64.92 0 0 1 50.62 22.72 16.42 16.42 0 0 1-3.74 25.06z",
    fill: "#20C997",
    "p-id": 5160
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M364 651.54a18.22 18.22 0 0 1-18.2-18.24v-20.72a18.2 18.2 0 1 1 36.4 0v20.72a18.22 18.22 0 0 1-18.2 18.24zM364 400.68a18.22 18.22 0 0 1-18.2-18.24v-20.72a18.2 18.2 0 1 1 36.4 0v20.72a18.22 18.22 0 0 1-18.2 18.24z",
    fill: "#20C997",
    "p-id": 5161
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M435 620.82h66.24v223.28H435zM550.92 620.82h66.24v223.28h-66.24zM666.84 620.82h66.24v223.28h-66.24zM783.02 620.82h66.3v223.28h-66.3z",
    fill: "#FCC419",
    "p-id": 5162
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.06 834.62h66.14a16.62 16.62 0 0 1 16.62 16.62V868h-99.38v-16.72a16.62 16.62 0 0 1 16.62-16.66zM550.98 834.62h66.14a16.62 16.62 0 0 1 16.62 16.62V868h-99.38v-16.72a16.62 16.62 0 0 1 16.62-16.66zM666.9 834.62h66.14a16.62 16.62 0 0 1 16.62 16.62V868h-99.38v-16.72a16.62 16.62 0 0 1 16.62-16.66zM783.08 834.62h66.2a16.62 16.62 0 0 1 16.62 16.62V868h-99.44v-16.72a16.62 16.62 0 0 1 16.62-16.66z",
    fill: "#FAB005",
    "p-id": 5163
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M403.44 866.36h484.26a22.82 22.82 0 0 1 22.82 22.82v20.52a2.28 2.28 0 0 1-2.28 2.28H382.88a2.28 2.28 0 0 1-2.28-2.28V889.2a22.82 22.82 0 0 1 22.84-22.84z",
    fill: "#FFD43B",
    "p-id": 5164
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M876.24 630.88H407.76a16.92 16.92 0 0 1-16.92-16.92v-17.3h502.32v17.3a16.92 16.92 0 0 1-16.92 16.92z",
    fill: "#FAB005",
    "p-id": 5165
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M633.16 394.68l-257.42 170.6c-14 9.3-7.76 32 8.84 32h514.84c16.6 0 22.88-22.76 8.84-32l-257.42-170.6a16 16 0 0 0-17.68 0z",
    fill: "#FFD43B",
    "p-id": 5166
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M592.32 511.44a50 49.68 90 1 0 99.36 0 50 49.68 90 1 0-99.36 0Z",
    fill: "#FAB005",
    "p-id": 5167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundAccount);
export default __webpack_public_path__ + "static/media/fundAccount.5cc63b7f9e41d284b97de50a44f1566b.svg";
export { ForwardRef as ReactComponent };